import React, { useCallback } from 'react';
import defaultsDeep from 'lodash/defaultsDeep';
import { Modal as AntdModal, ModalProps } from 'antd';

export const useModal: typeof AntdModal.useModal = () => {
  const [modal, modalInstance] = AntdModal.useModal();
  const originalConfirm = modal.confirm;
  const defaultProps = {
    icon: null,
    centered: true,
    closable: true,
    maskClosable: true,
    className: 'md_modal',
    modalRender: (node) => <div data-testid="customModal">{node}</div>,
    okButtonProps: {
      'data-testId': 'btnSave',
    },
    cancelButtonProps: {
      'data-testId': 'btnCancel',
    },
  } as ModalProps;

  modal.confirm = useCallback(
    (props) => originalConfirm(defaultsDeep({}, props, defaultProps)),
    [],
  );
  return [
    modal,
    // When the modal is triggered from inside a table cell, clicks on modal are being propagated and the table' onRow click is triggered
    <div style={{ display: 'none' }} onClick={(e) => e.stopPropagation()}>
      {modalInstance}
    </div>,
  ];
};

export const Modal: React.FC<ModalProps> = (props) => (
  // When the modal is triggered from inside a table cell, clicks on modal are being propagated and the table' onRow click is triggered
  <div style={{ display: 'none' }} onClick={(e) => e.stopPropagation()}>
    <AntdModal
      {...props}
      data-testid="customModal"
      okButtonProps={{ ...props.okButtonProps, 'data-testId': 'btnSave' }}
      cancelButtonProps={{ ...props.cancelButtonProps, 'data-testId': 'btnCancel' }}
      centered
    />
  </div>
);
